import {
  GET_ROM_LOCATION_LIST,
  GET_ROM_LOCATION_DETAIL,
} from 'fixtures/actions'

let initialState = []

const romLocationsList = (state = initialState, action) => {
  switch (action.type) {
    case GET_ROM_LOCATION_LIST:
      return [...action.payload]
    default:
      return state
  }
}

let initialStateDetail = {}

const romLocationDetailId = (state = initialStateDetail, action) => {
  switch (action.type) {
    case GET_ROM_LOCATION_DETAIL:
      return { ...action.payload }
    default:
      return state
  }
}

export { romLocationsList, romLocationDetailId }
